var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":function($event){return _vm.click($event)}}},[(_vm.hasIcon)?_c('v-list-item-avatar',{attrs:{"size":"20"}},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v(" "+_vm._s(_vm.getIcon)+" ")])],1):_vm._e(),_c('v-list-item-content',{staticClass:"text2 secondary300"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }